import './App.css';
import { useEffect, useState } from 'react';

function App() {

  const [lamellesPos, setLamellesPos] = useState([0, 0, 0]);
  const [formDatas, setFormDatas] = useState({value: 'none'});
  const [uri, setUri] = useState(null);
  const [status, setStatus] = useState(false);

  const [possibilites, setPossibilites] = useState([13260, 13360, 13460]);
  const val = randomInt(0, 2);

  const animationLoose = () => {
    let newPos = [...lamellesPos];
    newPos[0] = possibilites[val];
    newPos[1] = possibilites[(val === 2) ? 0 : val + 1];
    newPos[2] = possibilites[(val === 0) ? 2 : val - 1];
    setLamellesPos(newPos);
  }

  // 1300;
  // ??1260?
  const animationKeygen = () => {
    let newPos = [...lamellesPos];
    newPos[0] = 13260; 
    newPos[1] = 13260;
    newPos[2] = 13260;
    setLamellesPos(newPos);
  }

  const animationSac = () => {
    let newPos = [...lamellesPos];
    newPos[0] = 13360;
    newPos[1] = 13360;
    newPos[2] = 13360;
    setLamellesPos(newPos);
  }

  const send = async () => {
    const formData = new FormData();
    formData.append("input[game_id]", "b506368e-3d41-437a-bab2-d36d1cf0d760");
    formData.append("input[lang]", "en");
  
    // Ajouter les données dynamiques (formDatas est supposé être un objet)
    for (let key in formDatas) {
      formData.append(`input[player_data][${key}]`, formDatas[key]);
    }
  
    try {
      let response = await fetch("https://api-gain.web-treeosk.online/play", {
        method: "POST",
        body: formData, // On envoie directement FormData
      });
  
      let responseData = await response.json(); // Récupérer la réponse en JSON
      console.log(responseData);
  
      // Vérifier si gain_id existe avant d'accéder à ses données
      if (responseData.data && responseData.data.id) {
        switch (responseData.data.id) {
          case "d3fea9a5-41a5-4a93-9965-8e43bdd26c52":
            animationKeygen();
            break;
          case '70fe4599-2293-4b65-a8ea-c0f5c54bcb11':
            animationSac();
            break;
          case '749b65c7-605c-45bf-87c2-fbfc13650e15':
            animationLoose();
            break;
          default:
            break;  
        }
        setTimeout(() => {
          setUri(responseData.data.uri);
        }, 10000);
      }
    } catch (error) {
      console.error("Erreur lors de la requête :", error);
    }
  };

  const start = () => {
    setStatus(true);
    const audio = new Audio('./assets/son.mp3');
    audio.play();
    setTimeout(() => {
      send();
    }, 500);
  };

  return (
    <div className="App">
      <div style={{position: 'fixed', zIndex: 500, background: 'url(./assets/box.png)', width: '80%', left: '10%', height: '80%', top: '10%', backgroundSize: 'cover'}}>
      </div>
      <div style={{position: 'fixed', zIndex: 100, width: '58%', background: 'white', height: '36%', left: '20%', top: '35%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row', gap: '4%'}}>
        <div style={{flex: 1, background: 'url(./assets/lamelle.jpg)', width: '100%', height: '100%', backgroundSize: '100%', backgroundPositionY: `${lamellesPos[0]}%`, transitionDuration: '7s'}}>

        </div>
        <div style={{flex: 1, background: 'url(./assets/lamelle.jpg)', width: '100%', height: '100%', backgroundSize: '100%', backgroundPositionY: `${lamellesPos[1]}%`, transitionDuration: '8s'}}>

        </div>
        <div style={{flex: 1, background: 'url(./assets/lamelle.jpg)', width: '100%', height: '100%', backgroundSize: '100%', backgroundPositionY: `${lamellesPos[2]}%`, transitionDuration: '9s'}}>

        </div>
      </div>
      {
        uri && <img src={uri} alt='gain' style={{position: 'fixed', zIndex: 4000, height: '50%', width: '50%', left: '25%', top: '25%'}}/>
      }
      {
        !status &&
        <button onClick={start} style={{position: 'fixed', zIndex: 5000, fontSize: '2vw', top: '50%', left: '40%', width: '20%', border: 'solid 0.4em #FFD0E0', borderRadius: '1em', background: 'pink', padding: '1em', fontWeight: 'bold', color: '#FB008C'}}>
          CLICK HERE TO PLAY
        </button>
      }
    </div>
  );
}

const randomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
}

export default App;
